module.exports = __webpack_public_path__ + "static/exam-483-programming-in-c-015869a33c40fdd529300a337bd43c14.png";